import { baseApi as api } from "./baseApi";
var injectedRtkApi = api.injectEndpoints({
    endpoints: function (build) { return ({
        getChapterDefinitions: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions"),
            }); },
        }),
        createChapterDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        getChapterDefinition: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions/").concat(queryArg.chapterDefinitionId),
            }); },
        }),
        updateChapterDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions/").concat(queryArg.chapterDefinitionId),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        deleteChapterDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions/").concat(queryArg.chapterDefinitionId),
                method: "DELETE",
                body: queryArg.body,
            }); },
        }),
        updateChapterDefinitionsPositions: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/chapter_definitions/update_positions"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        getFormTemplates: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates"),
            }); },
        }),
        createFormTemplate: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        updateFormTemplate: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates/").concat(queryArg.formTemplateId),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        updateFormTemplateActive: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates/").concat(queryArg.formTemplateId, "/active"),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        duplicateFormTemplate: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates/").concat(queryArg.formTemplateId, "/duplicate"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        updateFormTemplateTrialContainers: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates/").concat(queryArg.formTemplateId, "/trial_containers"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        updateFormTemplateWorkflowDefinitions: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/form_templates/").concat(queryArg.formTemplateId, "/workflow_definitions"),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        getStudyProtocols: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols"),
            }); },
        }),
        createStudyProtocol: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        getStudyProtocol: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId),
            }); },
        }),
        updateStudyProtocol: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        deleteStudyProtocol: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId),
                method: "DELETE",
            }); },
        }),
        duplicateStudyProtocol: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/duplicate"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        createStudyEventDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_event_definitions"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        updateStudyeventDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_event_definitions/").concat(queryArg.studyEventDefinitionId),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        deleteStudyeventDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_event_definitions/").concat(queryArg.studyEventDefinitionId),
                method: "DELETE",
                body: queryArg.body,
            }); },
        }),
        createStudyEventProcedure: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_event_procedures"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        deleteStudyEventProcedure: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_event_procedures/").concat(queryArg.studyEventProcedureId),
                method: "DELETE",
                body: queryArg.body,
            }); },
        }),
        createStudyProcedureDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_procedure_definitions"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        updateStudyProcedureDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_procedure_definitions/").concat(queryArg.studyProcedureDefinitionId),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        deleteStudyProcedureDefinition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/study_procedure_definitions/").concat(queryArg.studyProcedureDefinitionId),
                method: "DELETE",
                body: queryArg.body,
            }); },
        }),
        updateStudyProtocolSites: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/study_protocols/").concat(queryArg.studyProtocolId, "/update_sites"),
                method: "PUT",
                body: queryArg.body,
            }); },
        }),
        getSubjectRequirements: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/subject_requirements"),
            }); },
        }),
        updateSubjectRequirements: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/subject_requirements"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        getTrialContainers: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/trial_containers"),
            }); },
        }),
        getWorkflowDefinitions: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/administration/workflow_definitions"),
            }); },
        }),
    }); },
    overrideExisting: false,
});
export { injectedRtkApi as administrationApi };
export var useGetChapterDefinitionsQuery = injectedRtkApi.useGetChapterDefinitionsQuery, useCreateChapterDefinitionMutation = injectedRtkApi.useCreateChapterDefinitionMutation, useGetChapterDefinitionQuery = injectedRtkApi.useGetChapterDefinitionQuery, useUpdateChapterDefinitionMutation = injectedRtkApi.useUpdateChapterDefinitionMutation, useDeleteChapterDefinitionMutation = injectedRtkApi.useDeleteChapterDefinitionMutation, useUpdateChapterDefinitionsPositionsMutation = injectedRtkApi.useUpdateChapterDefinitionsPositionsMutation, useGetFormTemplatesQuery = injectedRtkApi.useGetFormTemplatesQuery, useCreateFormTemplateMutation = injectedRtkApi.useCreateFormTemplateMutation, useUpdateFormTemplateMutation = injectedRtkApi.useUpdateFormTemplateMutation, useUpdateFormTemplateActiveMutation = injectedRtkApi.useUpdateFormTemplateActiveMutation, useDuplicateFormTemplateMutation = injectedRtkApi.useDuplicateFormTemplateMutation, useUpdateFormTemplateTrialContainersMutation = injectedRtkApi.useUpdateFormTemplateTrialContainersMutation, useUpdateFormTemplateWorkflowDefinitionsMutation = injectedRtkApi.useUpdateFormTemplateWorkflowDefinitionsMutation, useGetStudyProtocolsQuery = injectedRtkApi.useGetStudyProtocolsQuery, useCreateStudyProtocolMutation = injectedRtkApi.useCreateStudyProtocolMutation, useGetStudyProtocolQuery = injectedRtkApi.useGetStudyProtocolQuery, useUpdateStudyProtocolMutation = injectedRtkApi.useUpdateStudyProtocolMutation, useDeleteStudyProtocolMutation = injectedRtkApi.useDeleteStudyProtocolMutation, useDuplicateStudyProtocolMutation = injectedRtkApi.useDuplicateStudyProtocolMutation, useCreateStudyEventDefinitionMutation = injectedRtkApi.useCreateStudyEventDefinitionMutation, useUpdateStudyeventDefinitionMutation = injectedRtkApi.useUpdateStudyeventDefinitionMutation, useDeleteStudyeventDefinitionMutation = injectedRtkApi.useDeleteStudyeventDefinitionMutation, useCreateStudyEventProcedureMutation = injectedRtkApi.useCreateStudyEventProcedureMutation, useDeleteStudyEventProcedureMutation = injectedRtkApi.useDeleteStudyEventProcedureMutation, useCreateStudyProcedureDefinitionMutation = injectedRtkApi.useCreateStudyProcedureDefinitionMutation, useUpdateStudyProcedureDefinitionMutation = injectedRtkApi.useUpdateStudyProcedureDefinitionMutation, useDeleteStudyProcedureDefinitionMutation = injectedRtkApi.useDeleteStudyProcedureDefinitionMutation, useUpdateStudyProtocolSitesMutation = injectedRtkApi.useUpdateStudyProtocolSitesMutation, useGetSubjectRequirementsQuery = injectedRtkApi.useGetSubjectRequirementsQuery, useUpdateSubjectRequirementsMutation = injectedRtkApi.useUpdateSubjectRequirementsMutation, useGetTrialContainersQuery = injectedRtkApi.useGetTrialContainersQuery, useGetWorkflowDefinitionsQuery = injectedRtkApi.useGetWorkflowDefinitionsQuery;
